import React, { useState } from "react";
import {
  FaUser,
  FaBook,
  FaMoneyBill,
  FaSignOutAlt,
  FaChevronDown,
  FaLock,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import "../assets/css/studentdashboard.css";

const Sidebar = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  // const rawToken = localStorage.getItem("token");
  // make sure you actually read from localStorage:
  const storedMatric = localStorage.getItem("matricNo");
  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <aside className="student-sidebar">
      <ul>
        <li onClick={() => navigate("/dashboard")}>Dashboard</li>
        <li onClick={() => navigate("/student-change-password")}> <FaLock/>Change Password</li>
        
        <li onClick={() => toggleDropdown(1)}>
          <FaUser /> Profile <FaChevronDown className="dropdown-icon" />
        </li>
        {openDropdown === 1 && (
          <ul className="dropdown">
            <li onClick={() => navigate("/student-profile")}>View Profile</li>

            <li onClick={() => navigate(`/edit-profile/${storedMatric}`)}> Edit Profile</li>
          </ul>
        )}

        <li onClick={() => toggleDropdown(2)}>
          <FaBook /> Courses <FaChevronDown className="dropdown-icon" />
        </li>
        {openDropdown === 2 && (
          <ul className="dropdown">
            <li onClick={() => navigate("/registered-courses")}>
              Registered Courses
            </li>
            <li onClick={() => navigate("/courses")}>Add Courses</li>
          </ul>
        )}

        <li onClick={() => toggleDropdown(3)}>
          <FaMoneyBill /> Fees <FaChevronDown className="dropdown-icon" />
        </li>
        {openDropdown === 3 && (
          <ul className="dropdown">
            <li onClick={() => navigate("/payment-history")}>
              Payment History
            </li>
            <li onClick={() => navigate("/pay-fees")}>Pay Fees</li>
          </ul>
        )}
         <li onClick={() => toggleDropdown(4)}>
          <FaBook /> Results <FaChevronDown className="dropdown-icon" />
        </li>
        {openDropdown === 4 && (
          <ul className="dropdown">
            <li onClick={() => navigate("/results")}>
              Check Results
            </li>
            <li onClick={() => navigate("/courses")}>Add Courses</li>
          </ul>
        )}

        <li onClick={handleLogout}>
          <FaSignOutAlt /> Logout
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
